module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\"></span></div>\r\n<div class=\"row prop-detail\">\r\n	<div class=\"row\">\r\n		<div class=\"col-md-8 subsection nopadding-r\">\r\n			<label class=\"prop-sublabel label-65\">Normal</label> \r\n			<div class=\"nopadding label-75\">\r\n				<input id=\"styleColorTextPicker\" name=\"styleColorText\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n				<input id=\"styleColorText\" name=\"styleColorText\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" style=\"float:right;\" value=\"")
    ; __append(escapeFn( styleColorText ))
    ; __append("\" />\r\n			</div>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n		<div class=\"col-md-12 subsection nopadding-r\">\r\n			<label class=\"prop-sublabel label-65\">Mouse Over</label> \r\n			<div class=\"nopadding label-75\"> \r\n				<input type=\"color\" id=\"styleColorTextOverPicker\" name=\"styleColorTextOver\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" value=\"")
    ; __append(escapeFn(styleColorTextOver))
    ; __append("\" />\r\n				<input type=\"text\" id=\"styleColorTextOver\" name=\"styleColorTextOver\" maxlength=\"7\" class=\"color-picker-text\" style=\" float:right;\" value=\"")
    ; __append(escapeFn(styleColorTextOver))
    ; __append("\" />\r\n			</div>\r\n		</div>  \r\n	</div>\r\n</div>\r\n")
  }
  return __output;

}